/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PropChallengeConditions } from './prop-challenge-conditions';

/**
 *
 * @export
 * @interface CreatePropChallengeDto
 */
export class CreatePropChallengeDto {
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    goalId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    entityId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    entityName: string;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    promoCode?: string;
    /**
     *
     * @type {number}
     * @memberof CreatePropChallengeDto
     */
    retryDiscountPercent?: number;
    /**
     *
     * @type {PropChallengeConditions}
     * @memberof CreatePropChallengeDto
     */
    conditions: PropChallengeConditions;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    type: CreatePropChallengeDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CreatePropChallengeDto
     */
    iconName?: string;
    /**
     *
     * @type {boolean}
     * @memberof CreatePropChallengeDto
     */
    autoApproved?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CreatePropChallengeDto
     */
    acceptTermsAndCondition?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum CreatePropChallengeDtoTypeEnum {
    Audition = 'audition',
    Funded = 'funded',
    Demo = 'demo',
}
